import React from "react";
import { Modal, Box, SpaceBetween, Button } from "@amzn/awsui-components-react";
import { IVersionConfirmationModalProps } from "./definitions";
import { renderVersionCollisionMessage } from "./version-utils";

const VersionConfirmationModal: React.FC<IVersionConfirmationModalProps> = ({
  visible,
  setVisible,
  collisions,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm();
    setVisible(false);
  };

  const renderMessage = () => {
    if (collisions.length === 0) {
      return null;
    }
    return renderVersionCollisionMessage(collisions);
  };

  return (
    <Modal
      onDismiss={() => setVisible(false)}
      visible={visible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={() => setVisible(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleConfirm}>
              Confirm
            </Button>
          </SpaceBetween>
        </Box>
      }
      header="Confirm version creation"
    >
      <SpaceBetween direction="vertical" size="m">
        {renderMessage()}
      </SpaceBetween>
    </Modal>
  );
};

export default VersionConfirmationModal;
